import { useState, useEffect } from "react";
import SocialMediaIcons from "../SocialMediaIcons";
import { Link, NavLink, useLocation } from "react-router-dom";
import navLinksJson from "../../data/navLinks.json";
import Card from "../Card";
import MobileMenu from "../MobileMenu";
import Navbar from "../Navbar";
import "./header.css"; // Importing the CSS file

export default function Header() {
  const navLinks = navLinksJson;
  const location = useLocation();
  const [show, setShow] = useState(true);
  const [subMenu, setSubMenu] = useState(null);
  const [menu, setMenu] = useState(false);

  const handleNavbar = () =>
    window.scrollY === 0 ? setShow(true) : setShow(false);

  const handleSubMenu = (submenuIndex) =>
    subMenu === submenuIndex ? setSubMenu(null) : setSubMenu(submenuIndex);

  useEffect(() => {
    window.addEventListener("scroll", handleNavbar);
    return () => {
      window.removeEventListener("scroll", handleNavbar);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 767) {
        window.addEventListener("scroll", handleNavbar);
      } else {
        window.removeEventListener("scroll", handleNavbar);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("scroll", handleNavbar);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    document.body.style.overflow = menu ? "hidden" : "";
  }, [menu]);

  return (
    <div className="Header h-auto md:h-[122px] w-full absolute text-white md:fixed z-10 md:top-0 md:left-0">
      <div className="absolute inset-0">
        <MobileMenu
          menu={menu}
          setMenu={setMenu}
          navLinks={navLinks}
          NavLink={NavLink}
          subMenu={subMenu}
          handleSubMenu={handleSubMenu}
          setSubMenu={setSubMenu}
          location={location}
        />

        <div
          className={`header-bg absolute md:top-0 md:left-0 w-full h-auto ${show ? "h-[100%]" : "h-auto"
            } -z-10`}
        ></div>

        <div className="container-1280 header-container relative md:w-[750px] lg:w-[970px] xl:w-[100%] mx-auto px-[15px]">
          <div
            className={`header-first flex w-full py-[5px] md:py-0 items-center justify-start text-xs overflow-hidden transition-all duration-200 ease-out ${show || window.innerWidth < 768 ? "mt-0" : "mt-2"
              }`}
          >

            <div className="header-first-icons m-[10px] md:m-0">
              <SocialMediaIcons />
            </div>

            <div className="header-first-contact">
              <div className="m-[10px] text-[13px] md:text-[13px] md:ml-4">
                QUESTIONS? CALL:{" "}
                <a href="tel:+1 (832) 278-2928" className="font-bold  ">
                  +1 (832) 278-2928
                </a>
              </div>
            </div>
          </div>
          <div className="divider hidden md:block opacity-20 bg-white w-full h-[1px]"></div>

          <div
            className={`relative flex flex-row items-center justify-between ${show ? "mt-0" : "mt-0"
              } w-full header-last px-[10px] md:px-0`}
          >
            <div className="flex lg:flex-row items-center lg:justify-start justify-between flex-row-reverse m-auto w-full md:w-[22%]">
              <div className="relative left-10 flex justify-center w-full my-5 md:my-0 md:mt-[3px] logo-container group">
                <Link to="/">
                  <img
                    src="/assets/mean3-logo.png"
                    className="w-[118px] h-[70px]"
                    alt="Mean3 Logo"
                  />
                </Link>
                <Card />
              </div>


              <svg
                onClick={() => setMenu(!menu)}
                viewBox="0 0 24 24"
                fill="currentColor"
                height="25px"
                width="25px"
                className="block cursor-pointer opacity-80 lg:hidden"
              >
                <path
                  fillRule="evenodd"
                  d="M3 5C3 4.44772 3.44772 4 4 4H20C20.5523 4 21 4.44772 21 5C21 5.55228 20.5523 6 20 6H4C3.44772 6 3 5.55228 3 5ZM3 12C3 11.4477 3.44772 11 4 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H4C3.44772 13 3 12.5523 3 12ZM3 19C3 18.4477 3.44772 18 4 18H20C20.5523 18 21 18.4477 21 19C21 19.5523 20.5523 20 20 20H4C3.44772 20 3 19.5523 3 19Z"
                  stroke="currentColor"
                  strokeWidth="1"
                />
              </svg>
            </div>
            <div className="w-[40%] md:w-[78%] flex justify-between items-center nav-container">
              <nav className="w-full">
                <Navbar navLinks={navLinks} location={location} NavLink={NavLink} />
              </nav>
              <Link
                to="/contact-mean3"
                className="px-[10px] text-[11px] uppercase leading-[22px] rounded-sm relative font-open top-9 md:top-0 left-0 pb-[5px] pt-[10px] bg-[#cd2122] font-bold cursor-pointer hover:bg-white hover:text-black flex flex-col"
              >
                <strong className="text-[17px]">Free</strong>
                <span>Quote</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
